module.exports = __webpack_public_path__ + "img/asystent.af522fc9.png";